<script setup lang="ts">
import type { AccordionItem } from './Item.vue'

interface Props {
  anchor?: string
  title?: string
  items?: AccordionItem[]
}

const props = defineProps<Props>()

const selectedElement = ref<number>()
const isActive = (itemIndex: number): boolean => {
  return selectedElement.value === itemIndex
}
const hasItems = computed<boolean>(() => !!(props.items && props.items.length > 0))
</script>

<template>
  <SectionWrapper
    v-if="hasItems"
    :anchor
    class="accordion"
  >
    <Wrapper class="accordion__container">
      <UIDynamicHeading
        v-if="title"
        level="2"
        as="h3"
        class="accordion__title"
      >
        {{ title }}
      </UIDynamicHeading>
      <div class="accordion__list">
        <ContentBlockAccordionItem
          v-for="(item, index) in items"
          :key="`accordion-item-${String(index)}`"
          v-bind="item"
          :is-active="isActive(index)"
          class="accordion__item-wrapper"
          @select="selectedElement = isActive(index) ? undefined : index"
        />
      </div>
    </Wrapper>
  </SectionWrapper>
</template>

<style lang="scss" scoped>
.accordion {
  @apply mb-[30px];
  @apply md:mb-[50px];
  @apply xl:mb-[80px];
  @apply first:pt-[30px] first:md:pt-[50px];

  &__container {
    @apply flex flex-col items-center gap-8;
    @apply xl:gap-12;
  }

  &__list {
    @apply w-full max-w-[1000px];
  }
}
</style>
